import { useState, useCallback } from 'react';

export const LANGS = [
  { code: 'ru', label: 'RU', flag: '🇷🇺' },
  { code: 'uz', label: 'UZ', flag: '🇺🇿' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
];

export const UI = {
  ru: {
    menu:          'меню',
    allCategories: '← Все категории',
    loading:       'Загрузка меню...',
    order:         'Оформить заказ',
    callWaiter:    'Вызвать официанта',
    askBill:       'Попросить счёт',
    total:         'Итого',
    table:         'Стол',
    comment:       'Комментарий к заказу',
    commentHint:   'Пожелания, аллергии, без лука...',
    orderCreated:  'принят!',
    orderNum:      'Заказ №',
    toPay:         'К оплате',
    payPayme:      'Оплатить через Payme',
    close:         'Закрыть',
    waiterComing:  'Официант уже идёт!',
    billComing:    'Счёт уже несут!',
    willBeLater:   'будет позже',
    addItem:       'Добавить',
    addMore:       'Ещё',
  },
  uz: {
    menu:          'menyu',
    allCategories: '← Barcha kategoriyalar',
    loading:       'Menyu yuklanmoqda...',
    order:         'Buyurtma berish',
    callWaiter:    'Ofitsiant chaqirish',
    askBill:       'Hisob so\'rash',
    total:         'Jami',
    table:         'Stol',
    comment:       'Buyurtmaga izoh',
    commentHint:   'Istaklar, allergiya, piyozsiz...',
    orderCreated:  'qabul qilindi!',
    orderNum:      'Buyurtma №',
    toPay:         'To\'lash kerak',
    payPayme:      'Payme orqali to\'lash',
    close:         'Yopish',
    waiterComing:  'Ofitsiant kelmoqda!',
    billComing:    'Hisob olib kelinmoqda!',
    willBeLater:   'keyin bo\'ladi',
    addItem:       'Qo\'shish',
    addMore:       'Yana',
  },
  en: {
    menu:          'menu',
    allCategories: '← All categories',
    loading:       'Loading menu...',
    order:         'Place order',
    callWaiter:    'Call waiter',
    askBill:       'Ask for bill',
    total:         'Total',
    table:         'Table',
    comment:       'Order comment',
    commentHint:   'Wishes, allergies, no onion...',
    orderCreated:  'accepted!',
    orderNum:      'Order #',
    toPay:         'To pay',
    payPayme:      'Pay via Payme',
    close:         'Close',
    waiterComing:  'Waiter is coming!',
    billComing:    'Bill is on the way!',
    willBeLater:   'coming soon',
    addItem:       'Add',
    addMore:       'More',
  },
};

export function localizeItem(item, lang, field = 'name') {
  if (!item) return '';
  return (
    item[`${field}_${lang}`] ||
    item[`${field}_ru`]      ||
    item[field]              ||
    ''
  );
}

export function useLanguage() {
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('horeca_lang') || 'ru' : 'ru';
  const [lang, setLangState] = useState(saved);

  const setLang = useCallback((l) => {
    setLangState(l);
    if (typeof localStorage !== 'undefined') localStorage.setItem('horeca_lang', l);
  }, []);

  return { lang, setLang, t: UI[lang] || UI.ru, LANGS };
}
